import {
  isUnattributedApp,
  UNATTRIBUTED_APP_IDENTIFIER,
} from "../native/mergeSameDaySnapshot";
import { limitAggregatedEntities, type HeatmapEntity, type ViewMode } from "./heatmap";

export const UNATTRIBUTED_ENTITY_KEY = `app:${UNATTRIBUTED_APP_IDENTIFIER}`;

export function isUnattributedHeatmapEntity(
  entity: Pick<HeatmapEntity, "appIdentifier" | "displayName" | "key">,
): boolean {
  return isUnattributedApp(entity) || entity.key === UNATTRIBUTED_ENTITY_KEY;
}

export function shouldShowUnattributedInHabits(viewMode: ViewMode, includeOther: boolean): boolean {
  return viewMode === "app" && includeOther;
}

export function filterHabitsEntitiesForOther(
  entities: HeatmapEntity[],
  viewMode: ViewMode,
  includeOther: boolean,
): HeatmapEntity[] {
  if (shouldShowUnattributedInHabits(viewMode, includeOther)) return entities;
  return entities.filter((entity) => !isUnattributedHeatmapEntity(entity));
}

/** Top-N slice for Habits app mode, optionally appending Other when opted in. */
export function topHabitsAppEntities(
  allEntities: HeatmapEntity[],
  viewMode: ViewMode,
  includeOther: boolean,
): HeatmapEntity[] {
  const filtered = filterHabitsEntitiesForOther(allEntities, viewMode, includeOther);
  const sorted = [...filtered].sort((a, b) => b.total - a.total);
  const capped = limitAggregatedEntities(sorted, viewMode);
  if (!shouldShowUnattributedInHabits(viewMode, includeOther)) return capped;

  const other = allEntities.find(isUnattributedHeatmapEntity);
  if (!other || capped.some((entity) => entity.key === other.key)) return capped;
  return [...capped, other];
}

export function stripUnattributedFromKeys(keys: string[]): string[] {
  return keys.filter((key) => key !== UNATTRIBUTED_ENTITY_KEY);
}
